import React from 'react'
import { Edit } from 'react-admin'

import ExperienceForm from './form'

export const ExperienceEdit = (props) => (
  <Edit undoable={false} {...props}>
    <ExperienceForm isEdit={true} {...props} />
  </Edit>
)

export default ExperienceEdit
